import _construct from "@babel/runtime-corejs2/helpers/esm/construct";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import { convertTimeZoneToLocalTime, convertLocalTimeToTimeZone, getZoneDate, getZoneTime } from '..';
import stringToDateArray from '../utils/stringToDateObject';
describe('Date Time Module', function () {
  it('changes the date from one given time zone to the local time', function () {
    var originalDate = _construct(Date, _toConsumableArray(stringToDateArray('1 Sep 2018 18:01:36.386')));

    var timeZone = 'Europe/Berlin';
    var expectedDate = new Date('2018-09-01T16:01:36.386Z');
    var actualDate = convertTimeZoneToLocalTime(originalDate, timeZone);
    expect(actualDate).toEqual(expectedDate);
  });
  it('changes the date string from one given time zone to the local time', function () {
    var originalDate = new Date('10-21-2018');
    var timeZone = 'Europe/Berlin';
    var expectedDate = new Date('2018-10-20T22:00:00.000Z');
    var actualDate = convertTimeZoneToLocalTime(originalDate, timeZone);
    expect(actualDate).toEqual(expectedDate);
  });
  it('converts the date from the local time to one given time zone', function () {
    var originalDate = new Date('2018-09-01T16:01:36.386Z');
    var timeZone = 'Europe/Berlin';

    var expectedDate = _construct(Date, _toConsumableArray(stringToDateArray('09/01/2018 18:01:36.386')));

    var actualDate = convertLocalTimeToTimeZone(originalDate, timeZone);
    expect(actualDate).toEqual(expectedDate);
  });
  it('get date from timezone in default format', function () {
    var originalDate = new Date('2018-09-01T16:01:36.386Z');
    var timeZone = 'Europe/Berlin';
    var expectedDate = '01/09/2018';
    var actualDate = getZoneDate(originalDate, timeZone);
    expect(actualDate).toEqual(expectedDate);
  });
  it('get date from date to local timezone in custom format', function () {
    var originalDate = new Date('2018-09-01T16:01:36.386Z');
    var timeZone = 'Europe/Berlin';
    var expectedDate = '01 Sep 2018';
    var actualDate = getZoneDate(originalDate, timeZone, 'DD MMM YYYY');
    expect(actualDate).toEqual(expectedDate);
  });
  it('get time from date to local timezone in default format', function () {
    var originalDate = new Date('2018-09-01T16:01:36.386Z');
    var timeZone = 'Europe/Berlin';
    var expectedTime = '06:01 pm';
    var actualDate = getZoneTime(originalDate, timeZone);
    expect(actualDate).toEqual(expectedTime);
  });
  it('get time from date to local timezone in custom format', function () {
    var originalDate = new Date('2018-09-01T16:01:36.386Z');
    var timeZone = 'Europe/Berlin';
    var expectedTime = '06:01:36 pm';
    var actualDate = getZoneTime(originalDate, timeZone, 'hh:mm:ss a');
    expect(actualDate).toEqual(expectedTime);
  });
});